import { parseYmdDate } from '~~/shared/utils/date'

// ------------- 캠페인송 뮤직비디오 공모전 시작일/종료일 -------------
export const MUSIC_VIDEO_CONTEST_START_AT = '2026-06-05'
export const MUSIC_VIDEO_CONTEST_END_AT = '2026-08-31'

export function isMusicVideoContestOpen(at = new Date()): boolean {
  const start = parseYmdDate(MUSIC_VIDEO_CONTEST_START_AT)
  const end = parseYmdDate(MUSIC_VIDEO_CONTEST_END_AT)
  if (!start || !end)
    return false

  const endOfDay = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999)
  return at >= start && at <= endOfDay
}

// ------------- 연령 포맷팅 -------------
export interface AgeOption {
  ageGbSn: string
  ageTransKey: string
}

export const AGE_OPTIONS: AgeOption[] = [
  { ageGbSn: '10M', ageTransKey: '장남'},
  { ageGbSn: '10F', ageTransKey: '장여'},
  { ageGbSn: '20M', ageTransKey: '청남'},
  { ageGbSn: '20F', ageTransKey: '청여'},
  { ageGbSn: '21M', ageTransKey: '대남'},
  { ageGbSn: '21F', ageTransKey: '대여'},
  { ageGbSn: '30M', ageTransKey: '학남'},
  { ageGbSn: '30F', ageTransKey: '학여'},
]

export function formatAgeLabel(code: string | null | undefined): string {
  const age = AGE_OPTIONS.find(a => a.ageGbSn === code)
  if (!age)
    return ''
  return age.ageTransKey
}
